import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_LIST } from '../../../../../../constants/common'
import {
  NOTIFICATION_FILE_UPLOAD,
  NOTIFICATION_FILE_UPLOADED_WITH_ERRORS,
} from '../../../../../../constants/notification'
import {
  useInlineNotifications,
  useNotification,
  useUserData,
} from '../../../../../../hooks'
import {
  getFormNotificationFilesIsUploading,
  getFormNotificationFilesWithErrors,
} from '../../../../../../utils/notification'
import { useFileUpload } from '../../../../../File'
import {
  getMockViewingDocumentUploads,
  postMockViewingDocuments,
} from '../../../../../RentalPortalViewing'

export function useViewingDocumentUploadForm({
  viewingId,
  onClose,
  onUploaded,
}) {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const [files, setFiles] = useState(EMPTY_LIST)
  const [isSaving, setSaving] = useState(false)

  function handleForgetFile() {
    return null
  }

  const {
    filesError,
    filesUploading,
    handleRemoveFile,
    handleStartUploading,
    handleUploadErrors,
    handleUploadFile,
  } = useFileUpload({
    files,
    onDeleteFile: handleForgetFile,
    onSetFiles: setFiles,
  })

  async function handleGetFiles({ files: pickedFiles }) {
    return getMockViewingDocumentUploads({ files: pickedFiles })
  }

  function handleSave() {
    if (!isEmpty(filesUploading)) {
      handleAddNotification(getFormNotificationFilesIsUploading(t))
    } else if (!isEmpty(filesError)) {
      handleAddNotification(getFormNotificationFilesWithErrors(t))
    } else {
      setSaving(true)

      postMockViewingDocuments({ currentUser, files, viewing_id: viewingId })
        .then(() => {
          handleAddSuccessNotification({
            title: t('RentalPortal.ViewingDocumentUploadedNotificationKey', {
              count: files.length,
            }),
          })

          onUploaded()
          onClose()

          setSaving(false)
        })
        .catch(() => {
          handleAddErrorNotification(
            'RentalPortal.ViewingDocumentUploadErrorNotificationKey'
          )

          setSaving(false)
        })
    }
  }

  useEffect(() => {
    if (filesUploading.length === 0) {
      handleRemoveNotification(NOTIFICATION_FILE_UPLOAD)
    }

    if (filesError.length === 0) {
      handleRemoveNotification(NOTIFICATION_FILE_UPLOADED_WITH_ERRORS)
    }
  }, [filesError.length, filesUploading.length])

  return {
    files,
    filesError,
    filesUploading,
    handleGetFiles,
    handleRemoveFile,
    handleSave,
    handleStartUploading,
    handleUploadErrors,
    handleUploadFile,
    isSaving,
    notifications,
  }
}
